module.exports = __webpack_public_path__ + "static/squat-it-d041d94878a6cadbc576660962cb3c26.mp4";